import { render, staticRenderFns } from "./InviteCode.vue?vue&type=template&id=af011148&scoped=true&"
import script from "./InviteCode.vue?vue&type=script&lang=js&"
export * from "./InviteCode.vue?vue&type=script&lang=js&"
import style0 from "./InviteCode.vue?vue&type=style&index=0&id=af011148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af011148",
  null
  
)

export default component.exports